import client from 'app/client';

/** Natures de personne morale (Codes.NaturesPersonneMorale côté backend). */
export const PM_NATURES = {
  COURTIER: 'CRT',
  COMPAGNIE: 'CIE',
  GESTIONNAIRE: 'GST',
  MIA: 'MIA',
} as const;

export interface CurrentAccess {
  accessId: string;
  personneMoraleId: string;
  /** Null pour une PM sans ligne Courtier (ex. nature Compagnie). */
  courtierId: string | null;
  abpUserId: string;
  /** Gérant du cabinet : équipe, portefeuille, habilitations, briques des membres. */
  isOwner: boolean;
  personneMoraleDesignation: string;
  /** Nature de la PM (CRT/CIE/GST/MIA), null pour une PM non typée. */
  nature?: string | null;
}

export interface PersonneMoralePlateforme {
  plateformeId: string;
  displayName: string;
  isPrincipal: boolean;
  /** Titularité BRUTE (PM principale), sans tenir compte du mode de gestion :
   * ne jamais en déduire la gouvernance — consommer `gouverne`. */
  isPlateformeOwner: boolean;
  /** La PM GOUVERNE la plateforme : titulaire ET mode Gérée. C'est ce flag que
   * les écrans de gouvernance consomment — sur une plateforme administrée par
   * l'admin, le titulaire ne gouverne pas. */
  gouverne: boolean;
  dateRattachement: string;
}

export interface GetMyAccessResponse {
  access: CurrentAccess | null;
  plateformes: PersonneMoralePlateforme[];
}

/**
 * Récupère l'accès du user courant à sa personne morale (1 user = 0 ou 1 PM).
 * Retourne `access = null` pour les comptes admin / corporate.
 */
export async function getMyAccess(): Promise<GetMyAccessResponse> {
  const { data } = await client.get<GetMyAccessResponse>(
    '/backoffice/personnes-morales/me/access',
  );
  return data;
}
